import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    NgZone,
    OnInit,
    ViewChild,
    ViewRef,
} from "@angular/core";

import { Task } from "../../pojo/Task";
import { S25Util } from "../../util/s25-util";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { TaskService } from "../../services/task/task.service";
import { Table } from "../s25-table/Table";
import { Bind } from "../../decorators/bind.decorator";
import { S25TableComponent } from "../s25-table/s25.table.component";
import { CacheRepository } from "../../decorators/cache.decorator";
import { S25CheckboxComponent } from "../s25-checkbox/s25.checkbox.component";
import { S25EditableTextareaComponent } from "../s25-editable/s25-editable-textarea/s25.editable.textarea.component";
import { S25EditableDateComponent } from "../s25-editable/s25-editable-date/s25.editable.date.component";
import { S25TaskEditComponent } from "../s25-task/s25.task.edit.component";
import { S25TaskAssignComponent } from "../s25-task/s25.task.assign.component";
import { Api } from "../../api/api";
import { ContactService } from "../../services/contact.service";
import { TaskViewApi } from "../s25-task-view/s25.task.view.component";
import { jSith } from "../../util/jquery-replacement";
import TaskList = Task.TaskListI;
import { S25TaskActionComponent } from "./s25.task.action.component";
import { S25TaskStatusComponent } from "./s25.task.status.component";
import { TaskNormalizeUtil } from "../../services/task/task.normalize.util";
import { OptBean } from "../s25-opt/s25.opt.component";
import TaskListTaskItem = Task.TaskListTaskItem;
import { Item } from "../../pojo/Item";
import { TaskCompetingUtil } from "./task.competing.util";
export class EventTaskWorkListApi extends Api {
    static refresh(relativeElem: HTMLElement) {
        return Api.callApiFn(relativeElem, "s25-ng-event-task-list", null, null, (comp: S25EventTaskListComponent) => {
            comp.refreshF();
        });
    }
}
export interface TaskViewModelI {
    optBean: OptBean;
    messages: string;
    isInit: boolean;
    getRow: Task.TaskListI[];
    workflowChained?: boolean;
    optBeanRunTime?: any;
}
@TypeManagerDecorator("s25-ng-event-task-list")
@Component({
    selector: "s25-ng-event-task-list",
    template: `
        @if (init) {
            <div class="task-wrapper">
                <div class="c-margin-bottom--half">
                    @if (initTaskList && taskList.length > 0) {
                        <s25-ng-task-buttons
                            [modelBean]="selectedItems"
                            (onRefresh)="onTaskButtonRefresh()"
                        ></s25-ng-task-buttons>
                    }
                    <s25-ng-table
                        [dataSource]="tableConfig"
                        [columnSortable]="true"
                        [hasFilter]="false"
                        [hasRefresh]="false"
                        [pivotThreshold]="800"
                        [hasSelect]="hasSelect"
                        [hasSelectAll]="hasSelectAll"
                        [noResultsMessage]="'No Tasks Found'"
                        (selectedChange)="selectedChange($event)"
                    ></s25-ng-table>
                    @if (initTaskList && taskList.length > 0) {
                        <s25-ng-task-buttons
                            [modelBean]="selectedItems"
                            (onRefresh)="onTaskButtonRefresh()"
                        ></s25-ng-task-buttons>
                    }
                </div>
            </div>
        }
    `,
    styles: `
        ::ng-deep s25-ng-event-task-list tbody tr td input[type="checkbox"] {
            height: 16px !important;
        }

        ::ng-deep s25-ng-event-task-list s25-item {
            color: rgb(37, 115, 167);
        }

        ::ng-deep s25-ng-event-task-listt s25-item s25-popover {
            display: block !important;
        }

        ::ng-deep s25-ng-event-task-list .s25-ng-table--cell.stateTentative {
            font-style: italic;
        }

        ::ng-deep s25-ng-event-task-list .s25-ng-table--cell.stateCancelled {
            color: #d62000;
            font-weight: 400;
        }

        ::ng-deep .nm-party--on s25-ng-event-task-list .s25-ng-table--cell.stateCancelled {
            color: #ff837a;
        }

        ::ng-deep s25-ng-event-task-list .s25-ng-table--cell.stateRequested_changes {
            color: #f90;
            font-weight: 400;
        }

        ::ng-deep .nm-party--on s25-ng-event-task-list .s25-ng-table--cell.stateRequested_changes {
            color: #ffb366;
        }
        ::ng-deep s25-ng-event-task-list s25-ng-table .italic {
            font-style: italic;
        }

        ::ng-deep s25-ng-event-task-list s25-ng-task-edit > span {
            display: block !important;
        }

        ::ng-deep ss25-ng-event-task-list s25-ng-table s25-ng-editable-date .editable-input {
            width: 100% !important;
        }

        ::ng-deep s25-ng-event-task-list s25-ng-table thead th.s25TableColumn {
            color: #000000cc !important;
            font-size: 14px;
            padding: 1em 0.5em !important;
        }

        ::ng-deep .nm-party--on s25-ng-event-task-list s25-ng-table thead th.s25TableColumn {
            color: #fff !important;
        }

        ::ng-deep s25-ng-event-task-list s25-ng-table .s25-ng-table--table {
            border: 1px solid #e5e5e5;
        }

        ::ng-deep s25-ng-event-task-list s25-ng-table tbody tr:not(:last-of-type) {
            border-bottom: 1px solid #e5e5e5;
        }

        ::ng-deep s25-ng-event-task-list s25-ng-table .s25-ng-table--header:not(:first-child),
        ::ng-deep s25-ng-event-task-list s25-ng-table .s25-ng-table--cell:not(:first-child) {
            border-left: 1px solid #e5e5e5;
        }

        ::ng-deep .nm-party--on s25-ng-event-task-list s25-ng-table .s25-ng-table--table {
            border: 1px solid rgba(255, 255, 255, 0.24);
        }

        ::ng-deep .nm-party--on s25-ng-event-task-list s25-ng-table tbody tr:not(:last-of-type) {
            border-bottom: 1px solid rgba(255, 255, 255, 0.24);
        }

        ::ng-deep .nm-party--on s25-ng-event-task-list s25-ng-table .s25-ng-table--header:not(:first-child),
        ::ng-deep .nm-party--on s25-ng-event-task-list s25-ng-table .s25-ng-table--cell:not(:first-child) {
            border-left: 1px solid rgba(255, 255, 255, 0.24);
        }

        ::ng-deep #s25 s25-ng-event-task-list .button-group {
            margin-left: 0.5em !important;
        }

        ::ng-deep #s25 s25-ng-event-task-list .c-label--checkbox {
            margin-left: 0 !important;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25EventTaskListComponent implements OnInit {
    @Input() modelBean: TaskViewModelI;

    @ViewChild(S25TableComponent) tableComponent: S25TableComponent;

    tableConfig: Table.DataSource;
    init: boolean;
    userId: number;
    initTaskList: boolean;
    taskList: TaskList[] = [];
    hasSelect: boolean = false;
    hasSelectAll: boolean = false;

    columns: Table.Column[] = [
        { id: "reference", header: "Reference", sortable: true },
        { id: "name", header: "Task Item", sortable: true },
        { id: "type", header: "Type", sortable: true },
        { id: "status", header: "Status", sortable: true },
        { id: "flag", header: "Flagged", sortable: false, align: "center", width: 60 },
        { id: "responseBy", header: "Respond By", sortable: true },
        { id: "firstDate", header: "First Date", sortable: true },
        { id: "action", header: "Action", sortable: false, minWidth: 50 },
        { id: "assignTo", header: "Assign To", sortable: true },
        { id: "comments", header: "Comments", sortable: true },
    ];

    selectedItems: { eventId: number; tasks: TaskListTaskItem[] };
    eventTaskCompetesData: Task.MicroTaskWs[];

    constructor(
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef,
        private zone: NgZone,
    ) {
        this.elementRef.nativeElement.angBridge = this;
    }

    async ngOnInit() {
        const eventCompetesData = await TaskService.getMicroTasksByEventIds(
            [this.modelBean.getRow[0].taskItem!.eventId],
            ["competes"],
        );
        this.eventTaskCompetesData = eventCompetesData;

        const find = this.columns.filter((i: Table.Column) => {
            return i.id === "reference";
        });
        if (!this.modelBean.optBean.showRelatedEvents) {
            find && find.length > 0 ? this.columns.splice(0, 1) : "";
        } else {
            find.length === 0
                ? this.columns.unshift({ id: "reference", header: "Reference", sortable: false, width: 95 })
                : "";
        }

        this.modelBean.messages = "";
        this.modelBean.isInit = true;

        this.tableConfig = {
            type: "unpaginated",
            columns: this.columns,
            dataSource: this.getEventTasks,
        };

        this.init = true;
        this.detectChanges();
    }

    @Bind
    async getEventTasks(query: Table.UnpaginatedQuery): Promise<Table.DataSourceResponse> {
        if (query.forceRefresh) CacheRepository.invalidateByService("TaskListServiceGetEventTasks"); // When user refreshes invalidate cache
        const data = this.modelBean.getRow;
        this.taskList = data;

        if (this.taskList.length > 0) {
            this.hasSelect = true;
            this.hasSelectAll = true;
            this.taskList = this.taskList.sort((a, b) => {
                const dateA = new Date(a.eventDate!);
                const dateB = new Date(b.eventDate!);
                return dateA.getTime() - dateB.getTime();
            });
        }

        const locationIds = [
            ...new Set(
                data
                    .filter((t) => t.taskItem?.objectType === Item.Ids.Location && (t.taskItem?.objectId ?? 0) > 0)
                    .map((t) => t.taskItem!.objectId!),
            ),
        ];
        const waitlistByLocationId = await TaskCompetingUtil.waitlistEnabledBatch(locationIds);
        for (const task of data) {
            if (task.taskItem?.objectType === Item.Ids.Location) {
                task.taskItem.waitlistEnabled = waitlistByLocationId.get(task.taskItem.objectId!) ?? false;
            }
        }

        const configs = data.map(this.mapConfigToRow);
        this.initTaskList = true;

        return {
            rows: configs,
            totalRows: configs.length,
        };
    }

    mapConfigToRow = (task: TaskList): Table.Row => {
        const assignedTo = task.assignedTo!;
        const taskItem = task.taskItem!;
        const actions = task.actions!;
        const status = task.status!;
        const flagged = task.flagged!;
        const respondBy = task.respondBy!;
        const eventDate = task.eventDate!;
        const comments = task.comments!;

        // @ts-ignore
        let contactNames: Table.Cell[] = [{ text: assignedTo.itemName, itemId: assignedTo.itemId }];
        if (assignedTo.task) {
            contactNames =
                assignedTo.task.approval_contact?.map((contact) => ({
                    text: contact.approval_contact_name,
                    itemId: contact.approval_contact_id,
                })) || [];
        }

        taskItem.contacts = TaskNormalizeUtil.eventTaskContactToObj(assignedTo.task?.approval_contact ?? []);

        if (actions.isTodo) {
            actions.assignedById === task.currentUserId || actions.assignedToId === task.currentUserId
                ? (task.readOnly = false)
                : (task.readOnly = true);
        } else {
            task.readOnly = !task.hasApproveDenyPerms;
        }

        // competes data for waitlist
        const found = this.eventTaskCompetesData.find(
            (t: Task.MicroTaskWs) =>
                t.id === taskItem.itemId && task.objectType === Item.Ids.Location && t.objectId === taskItem.objectId,
        );

        const competesData = found?.competes?.flatMap((c) => c.spaceCompetes) || [];

        taskItem.competes = competesData;
        taskItem.reservationId = assignedTo.task?.approval_profile_id;

        return {
            id: actions.itemId,
            name: actions.taskName,
            cells: {
                reference: { text: task.reference },
                name: {
                    component: S25TaskEditComponent,
                    inputs: {
                        taskModel: taskItem,
                        showIcon: true,
                        taskBlocked: false,
                        waitlistQueryKey: eventDate,
                    },
                    outputs: {
                        onRefresh: (val: string) => {
                            const el: any = document;
                            TaskViewApi.reset(el);
                        },
                    },
                    textValue: actions.taskName,
                },
                type: { text: task.type },
                status: {
                    component: S25TaskStatusComponent,
                    inputs: {
                        task: {
                            task_blocked: actions.taskBlocked,
                            task_state: status.itemStateId === 3 ? 3 : actions.itemStateId, // If denied for anyone, then denied for everyone
                            task_type: actions.itemTypeId,
                        },
                    },
                    textValue: status.itemName,
                },
                action: {
                    component: S25TaskActionComponent,
                    inputs: {
                        assignedToId: actions.assignedToId,
                        taskState: actions.itemStateId,
                        taskId: actions.itemId,
                        taskBlocked: actions.taskBlocked,
                        itemCount: actions.itemCount,
                        taskType: actions.itemTypeId,
                        requesterId: actions.requesterId,
                        eventId: actions.eventId,
                        todoType: taskItem.todoType,
                        todoSubType: taskItem.todoSubType,
                        competes: competesData,
                        objectType: task.objectType,
                        objectId: task?.taskItem?.objectId,
                        reservationId: task?.taskItem?.reservationId,
                    },
                    outputs: { stateChange: this.onTaskAction },
                },
                flag: {
                    component: S25CheckboxComponent,
                    inputs: {
                        value: flagged.value,
                        noLabel: true,
                        ariaLabel: `${flagged.value ? "Unset" : "Set"} flagged for ${actions.taskName}`,
                    },
                    outputs: {
                        valueChange: (val: boolean) => {
                            TaskService.setFlag(actions.itemTypeId, actions.itemId, val);
                        },
                    },
                },
                responseBy: {
                    component: S25EditableDateComponent,
                    inputs: { val: respondBy.date, readOnly: !task.hasApproveDenyPerms },
                    outputs: {
                        valChange: (val: string) => {
                            if (actions.isTodo) {
                                TaskService.putTodoDueDate(actions.itemId, val);
                            } else {
                                TaskService.putEventTaskDueDate(actions.eventId, actions.itemId, val);
                            }
                        },
                    },
                    textValue: respondBy.date.toString(),
                    sortValue: S25Util.date.toS25ISODateTimeStr(respondBy.date),
                },
                firstDate: {
                    component: S25EditableDateComponent,
                    inputs: { val: eventDate, readOnly: true },
                    outputs: {
                        valChange: (val: string) => {},
                    },
                    textValue: eventDate.toString(),
                    sortValue: S25Util.date.toS25ISODateTimeStr(eventDate),
                },
                assignTo: {
                    component: S25TaskAssignComponent,
                    inputs: {
                        items: contactNames,
                        taskItem: taskItem,
                        approval: assignedTo.task,
                        taskType: actions.itemTypeId,
                    },
                    textValue: assignedTo.itemName,
                },
                comments: {
                    component: S25EditableTextareaComponent,
                    inputs: { val: comments.value, readOnly: task.readOnly, renderHtml: true },
                    outputs: {
                        valChange: (val: string) => {
                            if (actions.isTodo) {
                                TaskService.putTodoComment(actions.itemId, val);
                            } else {
                                TaskService.putEventTaskComment(actions.eventId, actions.itemId, val);
                            }
                        },
                    },
                    textValue: comments.value,
                } satisfies Table.Cell<S25EditableTextareaComponent>,
            },
        };
    };

    @Bind
    onTaskAction(state: Task.State, context: Table.CellCallbackContext) {
        // Update task item column
        const taskItem = context.row.cells.name?.instance as S25TaskEditComponent;
        if (taskItem) {
            taskItem.taskModel.itemStateId = state;
            taskItem.refresh();
        }
        // Update status column
        const status = context.row.cells.status?.instance as S25TaskStatusComponent;
        if (status) {
            status.task.task_state = state;
            status.refresh();
        }
    }

    private getRowsByTaskId(taskIds: number[]) {
        return this.modelBean.getRow.filter((f: any) => {
            return taskIds.includes(f.actions.itemId);
        });
    }

    selectedChange(selectItem: Set<Table.Row["id"]>) {
        const selectedItem: number[] = Array.from(selectItem) as number[];
        const ret: number[] = [];
        let count = 0;
        //check select item has hasApproveDenyPerms
        jSith.forEach(selectedItem, (key, i) => {
            const find = this.modelBean.getRow.find((f: any) => {
                return i && f.hasApproveDenyPerms === true && f.actions.itemId === i;
            });
            if (find) {
                ret.push(i);
            } else {
                count++, this.tableComponent.selected.delete(i);
            }
            return ret;
        });

        this.selectedItems = {
            eventId: this.modelBean.getRow[0].taskItem!.eventId,
            tasks: this.getRowsByTaskId(ret).map((row) => row.taskItem!),
        };

        count > 0 ? alert("You do not have permission to approve or deny on one or more of the selected tasks!") : "";
    }

    async successF() {
        await S25Util.delay(250);
        this.detectChanges();
    }

    async refreshF() {
        await this.resetF();
    }

    async onTaskButtonRefresh() {
        await this.resetF();
    }

    async resetF() {
        this.init = false;
        this.detectChanges();
        await S25Util.delay(250);
        this.ngOnInit();
    }

    getData() {
        return Promise.all([ContactService.getCurrentName(), ContactService.getCurrentId()]).then(
            ([userName, userId]) => {
                return { userName, userId };
            },
        );
    }

    detectChanges() {
        try {
            setTimeout(() => {
                this.cd && !(this.cd as ViewRef).destroyed && this.cd.detectChanges();
            }, 60);
        } catch (error: any) {}
    }
}
